export default {
  items: [
    {
      name: 'Utilisateur',
      url: '/dashboard/liste-clients',
      icon: 'user-friends'
    },
    {
      name: 'Statistiques',
      url: '/dashboard/statistiques',
      icon: 'chart-line'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/placeholder/sidebarMenu.js